module.exports = __webpack_public_path__ + "img/airwaves.e95b4c69.jpg";